<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('users.entity_name')}}</label>
              <el-form-item prop="name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('users.email', 1)}}</label>
              <el-form-item prop="email">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.email.value"
                  maxlength="255"
                />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('app.role', 1)}}</label>
              <el-form-item prop="role">
                <base-el-select class="w-full" :options="roles" v-model="form.role.value" clearable filterable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.active')}}</label>
              <el-form-item prop="active">
                <base-el-select class="w-full" :options="values" v-model="form.active.value" clearable :placeholder=" $t('companies.active_yes_no')" />
              </el-form-item>
            </div>

            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('users.tipo_auth')}}</label>
              <el-form-item prop="tipoAuth">
                <base-el-select class="w-full" :options="tiposAuth" v-model="form.tipoAuth.value" clearable />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.language') }}</label>
              <el-form-item prop="LangCode">
                <base-el-select class="w-full" :options="tiposIdioma" v-model="form.idioma.value" />              
              </el-form-item>
            </div>
             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.ver_todo_statuses')}}</label>
              <el-form-item prop="verTodoStatuses">
                <base-el-select class="w-full" :options="values" v-model="form.verTodoStatuses.value" clearable :placeholder="$t('configurations.ver_todo_yes_no')" />
              </el-form-item>
            </div>
             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.ver_todo_companies')}}</label>
              <el-form-item prop="verTodoCompanies">
                <base-el-select class="w-full" :options="values" v-model="form.verTodoCompanies.value" clearable :placeholder="$t('configurations.ver_todo_yes_no')" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'groupusers',
      isOpen: this.panelOpen,
      links: [],
      form: {
        id: { label: i18n.t('app.id'), value: '' },
        name: { label: i18n.t('users.entity_name'), value: '' },
        email: { label: i18n.tc('users.email', 1), value: '' },
        company: { label: i18n.tc('companies.entity_name', 1), value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        active: { label: i18n.t('app.active'), value: '' },
        role: { label: i18n.tc('app.role', 1), value: '' },
        tipoAuth: { label: i18n.t('users.tipo_auth'), value: '' },
        idioma: { label: i18n.t('app.language'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },

  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    },
  },
  mounted: async function () {
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    roles: function () {
      return this.$store.getters['config/ROLES'].filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })
    },
    tiposAuth: function () {
      return this.$store.getters['config/TIPOS_AUTH']
    },
    tiposIdioma: function () {
      return this.$store.getters['config/TIPOS_IDIOMA']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.id.value = _temp.id !== undefined && _temp.id.value !== '' ? _temp.id.value : ''
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.company.value = _temp.company !== undefined && _temp.company.value !== '' ? _temp.company.value : ''
        this.form.verTodoStatuses.value = _temp.verTodoStatuses !== undefined && _temp.verTodoStatuses.value !== '' ? _temp.verTodoStatuses.value : ''
        this.form.verTodoCompanies.value = _temp.verTodoCompanies !== undefined && _temp.verTodoCompanies.value !== '' ? _temp.verTodoCompanies.value : ''
        this.form.active.value = _temp.active !== undefined && _temp.active.value !== '' ? _temp.active.value : ''
        this.form.role.value = _temp.role !== undefined && _temp.role.value !== '' ? _temp.role.value : ''
        this.form.tipoAuth.value = _temp.tipoAuth !== undefined && _temp.tipoAuth.value !== '' ? _temp.tipoAuth.value : ''
        this.form.idioma.value = _temp.idioma !== undefined && _temp.idioma.value !== '' ? _temp.idioma.value : ''
      }
    },
    watchFormHandler: function ({ certificate, send_alerts }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        id: { label: i18n.t('app.id'), value: '' },
        name: { label: i18n.t('users.entity_name'), value: '' },
        email: { label: i18n.tc('users.email', 1), value: '' },
        company: { label: i18n.tc('companies.entity_name', 1), value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        active: { label: i18n.t('app.active'), value: '' },
        role: { label: i18n.tc('app.role', 1), value: '' },
        tipoAuth: { label: i18n.t('users.tipo_auth'), value: '' },
        idioma: { label: i18n.t('app.language'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
